export class Thumb {
    id: number;
    realPath: string;
    thumbPath: string;
    imageDate: string;
}


// WEBPACK FOOTER //
// C:/pgutev/work/WEBCAM/src/app/models/thumb.model.ts